import { createSlice } from '@reduxjs/toolkit';
import ReducerConstants from '../../../_shared/constants/reducers';

const setMediaMetaData = (state, action) => ({
  ...state,
  ...action.payload
});

export const mediaMetaDataSlice = createSlice({
  name: ReducerConstants.MEDIA_METADATA,
  initialState: {},
  reducers: { setMediaMetaData }
});

export default mediaMetaDataSlice.reducer;
